import { CommonModule } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from "@angular/core";
import { NgApexchartsModule } from "ng-apexcharts";

@Component({
  selector: "app-donut-chart",
  templateUrl: "./donut-chart.component.html",
  styleUrls: ["./donut-chart.component.scss"],
  imports: [CommonModule, NgApexchartsModule],
  standalone: true,
})
export class DonutChartComponent implements OnChanges {
  @Output() dataEvent = new EventEmitter<any>();
  @Input() data: { label: string; count: number }[] = [];

  chartOptions: any;
  formattedData: { label: string; count: number; color: string }[] = [];

  @Input() colorMap: { [label: string]: string } = {}; // label -> color
  @Input() defaultColors: string[] = [
    "#E3000C",
    "#FFC300",
    "#4390E3",
    "#7CD169",
    "#FF7F50",
    "#9370DB",
  ];

  ngOnChanges(): void {
    if (this.data?.length) {
      this.prepareChart();
    }
  }
  isNoData: boolean = true;
  private prepareChart() {
    const isEmpty = !this.data || this.data.length === 0;
    const allZero = this.data.every((item) => item.count === 0);

    if (isEmpty || allZero) {
      this.isNoData = true;

      const dummyCount = 123456; // fixed equal value to make chart look circular

      // Keep original labels but override counts + color
      this.formattedData = (
        this.data.length
          ? this.data
          : Array.from({ length: 4 }).map((_, i) => ({
              label: this.data[i]?.label || `Item ${i + 1}`,
              count: 0,
            }))
      ).map((item) => ({
        label: item.label, // keep original label
        count: dummyCount, // all equal dummy values
        color: "#D1D5DB", // gray color
      }));
    } else {
      this.isNoData = false;

      this.formattedData = this.data.map((item, index) => ({
        ...item,
        color:
          this.colorMap[item.label] ||
          this.defaultColors[index % this.defaultColors.length],
      }));

      // this.chartColors = this.formattedData.map((item) => item.color);
    }

    this.chartOptions = {
      chart: {
        animations: {
          speed: 400,
          animateGradually: { enabled: false },
        },
        fontFamily: "inherit",
        foreColor: "inherit",
        height: "150px",
        type: "donut",
        sparkline: { enabled: true },
        events: {
          dataPointSelection: (event, chartContext, config) => {
            const selectedIndex = config.dataPointIndex;
            const label = this.chartOptions.labels[selectedIndex];
            const value = this.chartOptions.series[selectedIndex];
            this.dataEvent.emit({
              label,
              value,
              selectedIndex,
            });
            // You can emit an event, call a method, or navigate based on the selection
          },
        },
      },
      stroke: {
        show: false, // ✅ disables the white border between segments
      },
      colors: this.formattedData.map((item) => item.color),
      labels: this.formattedData.map((item) => item.label),
      plotOptions: {
        pie: {
          customScale: 1.0,
          expandOnClick: false,
          donut: { size: "58%" },
        },
      },
      series: this.formattedData.map((item) => item.count),
      states: {
        hover: { filter: { type: "none" } },
        active: { filter: { type: "none" } },
      },
      tooltip: {
        enabled: !this.isNoData,
        fillSeriesColor: false,
        theme: "dark",
        custom: ({ seriesIndex, w }) => `
          <div class="flex items-center h-8 min-h-8 max-h-8 px-3">
            <div class="w-3 h-3 rounded-full" style="background-color: ${w.config.colors[seriesIndex]};"></div>
            <div class="ml-2 text-md leading-none">${w.config.labels[seriesIndex]}:</div>
            <div class="ml-2 text-md font-bold leading-none">${w.config.series[seriesIndex]}%</div>
          </div>`,
      },
    };


    if (isEmpty || allZero) {
      this.formattedData = this.data.map((item, index) => ({
        ...item,
        color:
          this.colorMap[item.label] ||
          this.defaultColors[index % this.defaultColors.length],
      }));
    }
  }

  onChartClick(label, selectedIndex) {
    this.dataEvent.emit({
      label,
      value: label,
      selectedIndex,
    });
  }
}
